import React,{useEffect, useState} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import {MdFileDownload, MdVisibility} from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';


import {CustomIconButton} from '../../Component/FormUtils/FormUtils'
import { deleteMemberThunk, getAllMembersThunk } from '../../Store/members';
import AppLoader from '../../Component/AppLoader'
import ViewApplication from './ViewApplication';
import {FieldSelectWithOutFormik} from '../../Component/FormUtils/FormUtils'
import CustomSearch from '../../Component/CustomSearch'
import DeleteBox from '../../Component/DeleteBox'

const escapeCsvValue = (value) => {
  const stringValue = value === undefined || value === null ? '' : String(value)
  const spreadsheetSafeValue = /^[=+\-@]/.test(stringValue) ? `'${stringValue}` : stringValue

  return `"${spreadsheetSafeValue.replace(/"/g, '""')}"`
}

const exportMembersToCsv = (members) => {
  const headers = [
    'S/N',
    'Membership Number',
    'First Name',
    'Last Name',
    'Email',
    'Phone Number',
    'Gender',
    'State',
    'Membership Category',
    'Certificate',
    'Status',
  ]
  const rows = members.map((member, index) => [
    index + 1,
    member.membershipNumber,
    member.personalDetails?.firstName,
    member.personalDetails?.lastName,
    member.personalDetails?.email,
    member.personalDetails?.phone,
    member.personalDetails?.gender,
    member.personalDetails?.state,
    member.membershipCat,
    member.certificateStatus,
    member.status === undefined ? 'Not submitted' : member.status,
  ])
  const csv = [headers, ...rows]
    .map((row) => row.map(escapeCsvValue).join(','))
    .join('\r\n')
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = `members-${new Date().toISOString().slice(0, 10)}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}



export const DataTable = () => {

  const dispatch = useDispatch()
  const store = useSelector((state)=> state.member)
  const [tempData, setTempData] = useState(store.members)
  
  useEffect(()=>{
    dispatch(getAllMembersThunk()).then((val)=>{
      setTempData(val.payload.data)
    })
  },[])

  const [selectedUser, setSelectedUser] = useState(null)
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const [memberToDelete, setMemberToDelete] = useState(null)

  const handleDeleteMember = async () => {
    if (!memberToDelete) return

    try {
      await dispatch(deleteMemberThunk(memberToDelete._id)).unwrap()
      setTempData((members) => members.filter((member) => member._id !== memberToDelete._id))
      setDeleteDialogOpen(false)
      setMemberToDelete(null)
      toast.success('Member deleted')
    } catch (error) {
      toast.error('Unable to delete member. Please try again.')
    }
  }

  const handleCloseDeleteDialog = () => {
    if (store.deleteMemberLoading) return

    setDeleteDialogOpen(false)
    setMemberToDelete(null)
  }

  const [selectFilter, setSelectFilter] = useState('all')
  const [searchValue, setSeachValue] = useState('')

  const handleSelectFilter = (value) => {
    setSelectFilter(value)
    if (value === 'all'){
      setTempData(store.members)
    }
    else if(value === 'approved'){
      setTempData(store.members.filter(val => val.status !== undefined && val.status === 'Approved'))
    }
    else if(value === 'pending'){
      setTempData(store.members.filter(val => val.status !== undefined && val.status === 'Pending'))
    }
    else if(value === 'notSubmited'){
      setTempData(store.members.filter(val => val.status === undefined))
    }
  }

  const handleSearchValue = (value) => {
    setSeachValue(value)
    setSelectFilter('all')
    if(value.length >= 3){
      const pattern = new RegExp(`\D*${value}\D*`,'i')
      setTempData(store.members.filter(val => 
        (val.personalDetails.firstName.match(pattern) ||  val.personalDetails.lastName.match(pattern)) || val.personalDetails.email.match(pattern)))

    }

    if(value.length < 3){
      setTempData(store.members)
    }

  }

   
  return (
    <TableContainer className='h-[80vh] bg-[white] overflow-y-auto'>
      {open && <ViewApplication open={open} handleClose={handleClose} selectedUser={selectedUser} setTempData={setTempData}/>}

      <DeleteBox
        open={deleteDialogOpen}
        handleClose={handleCloseDeleteDialog}
        title={'Delete Member'}
        body={memberToDelete
          ? `Are you sure you want to delete ${memberToDelete.personalDetails?.firstName || 'this member'}? This action cannot be undone.`
          : 'Are you sure you want to delete this member? This action cannot be undone.'}
        deleteFunction={handleDeleteMember}
        loading={store.deleteMemberLoading}
      />

      <div className='my-3 flex flex-wrap items-center justify-between gap-3'>
        <div className='flex flex-wrap gap-3'>
          <CustomSearch searchValue={searchValue} handleChange={(e)=>handleSearchValue(e.target.value)}/>

          <FieldSelectWithOutFormik
          width='150px'
          list={[
            {id:'all', name:'All'},
            {id:'approved', name:'Approved'},
            {id:'pending', name:'Pending'},
            {id:'notSubmited', name:'Not Submited'},
          ]}
          callback={(e)=>{handleSelectFilter(e.target.value)}} value={selectFilter}
          />
        </div>

        <Button
          variant='contained'
          disableElevation
          startIcon={<MdFileDownload />}
          disabled={store.loading || tempData.length === 0}
          onClick={() => exportMembersToCsv(tempData)}
          sx={{
            height: '36px',
            textTransform: 'none',
            backgroundColor: '#2E7159',
            ':hover': { backgroundColor: '#245a47' },
          }}
        >
          Export CSV
        </Button>
      </div>

      
      <AppLoader loading={store.loading}>
        {tempData.length > 0 && <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead className='sticky top-0 bg-[white] z-[1000]'>
            <TableRow>
              <TableCellWithBorder text={'S/N'}/>
              <TableCellWithBorder text={'First Name'}/>
              <TableCellWithBorder text={'Last Name'}/>
              <TableCellWithBorder text={'Email'}/>
              <TableCellWithBorder text={'Certificate'}/>
              <TableCellWithBorder text={'Status'}/>
              <TableCellWithBorder text={'Action'}/>
            </TableRow>
          </TableHead>
          <TableBody>
            {tempData.map((row,index) => (
              <TableRow
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCellWithBorder text={index + 1}/>

                <TableCell className='border-1 border-border-color' component="th" scope="row">
                  {row.personalDetails.firstName}
                </TableCell>
                <TableCellWithBorder text= {row.personalDetails.lastName}/>
                <TableCellWithBorder text= {row.personalDetails.email}/>
                <TableCellWithBorder text= {row.certificateStatus}/>
                <TableCellWithBorder text= {row.status === undefined ? 'Not submitted' : row.status}/>

                
                <TableCell className='border-1 border-border-color' component="th" scope="row">
                  <CustomIconButton Icon={MdVisibility} callBack={()=> {setSelectedUser(row); handleOpen()}}/>
                  <IconButton
                    aria-label='Delete member'
                    onClick={() => {
                      setMemberToDelete(row)
                      setDeleteDialogOpen(true)
                    }}
                  >
                    <DeleteIcon className='text-[red]' sx={{ fontSize: '18px' }}/>
                  </IconButton>
                </TableCell>
                
              </TableRow>
            ))}
              
          </TableBody>
        </Table>}

      </AppLoader>

    </TableContainer>
  );
}

const TableCellWithBorder = ({text}) => {
  return (
    <TableCell className='border-1 border-border-color'>{text}</TableCell>

  )
}
